import { render, staticRenderFns } from "./order-item-edition-modal.vue?vue&type=template&id=b750fa6a&"
import script from "./order-item-edition-modal.vue?vue&type=script&lang=js&"
export * from "./order-item-edition-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports